// src/api/authApi.js
import axiosInstance from './axiosConfig';

export const authApi = {
  login: async (email, password) => {
    return axiosInstance.post('/auth/login', { email, password });
  },

  register: async (formData) => {
    // ✅ Important: When sending FormData, do not use the default JSON header
    return axiosInstance.post('/auth/register', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  logout: async () => {
    return axiosInstance.post('/auth/logout');
  },

  getMe: async () => {
    return axiosInstance.get('/auth/me');
  },
};